import React, { useState, useEffect } from 'react';
import Icon from '@mui/material/Icon';
import { hideResult } from '../Actions/ModalResult.action';
import { useDispatch } from 'react-redux';
import { translate } from '../../Services/translation';

const ModalResult = (props) => {
    const [showModalResult, setModalResultStatus] = useState(true);
    const dispatch = useDispatch();

    return (
        showModalResult && (    
            <div className="modal-result__container">
                <div className={`modal-result__background + ${props?.text?.length > 0 ? ' modal-result__background__opaque' : ''}`}>
                    <div className={`modal-result__icon ${props?.success === false ? ' modal-result__icon-error' : ''}`}>
                        <Icon>{props?.icon}</Icon>
                    </div>
                    <h4 className="modal-result__text">{props?.text}</h4>
                    <button className={`button button-cta modal-result__button ${props?.success === false ? 'modal-result__button--error' : '' }`} onClick={() => dispatch(hideResult())}>{translate('code.payinvoices.viewdetails')}</button>
                </div>
            </div>
        )
    );
};

export default ModalResult;